import Vue from "vue";

import MForm from "../components/MForm";
Vue.component("m-form", MForm);
import MFormBase from "../components/MFormBase";
Vue.component("m-form-base", MFormBase);
import MFormCombobox from "../components/MFormCombobox";
Vue.component("m-form-combobox", MFormCombobox);
import MFormRadioGroup from "../components/MFormRadioGroup";
Vue.component("m-form-radio-group", MFormRadioGroup);
import MFormRadio from "../components/MFormRadio";
Vue.component("m-form-radio", MFormRadio);
import MFormDate from "../components/MFormDate";
Vue.component("m-form-date", MFormDate);
import MFormDateHour from "../components/MFormDateHour";
Vue.component("m-form-date-hour", MFormDateHour);
import MConfirmDialog from "../components/MConfirmDialog";
Vue.component("m-confirm-dialog", MConfirmDialog);
import MMessageDialog from "../components/MMessageDialog";
Vue.component("m-message-dialog", MMessageDialog);
// import MComboboxOffer from "../components/MComboboxOffer";
// Vue.component("m-combobox-offer", MComboboxOffer);
// import MComboboxContact from "../components/MComboboxContact";
// Vue.component("m-combobox-contact", MComboboxContact);
// import MComboboxBuilding from "../components/MComboboxBuilding";
// Vue.component("m-combobox-building", MComboboxBuilding);
import MFormText from "../components/MFormText";
Vue.component("m-form-text", MFormText);
import MFormFiles from "../components/MFormFiles";
Vue.component("m-form-file", MFormFiles);
import MFormImages from "../components/MFormImages";
Vue.component("m-form-images", MFormImages);
import MFormSelect from "../components/MFormSelect";
Vue.component("m-form-select", MFormSelect);
import MList from "../components/MList";
Vue.component("m-list", MList);
import MLoaderDialog from "../components/MLoaderDialog";
Vue.component("m-loader-dialog", MLoaderDialog);

import ResearchView from "../views/ResearchView";
Vue.component("research-view", ResearchView);
import ContactDetails from "../views/ContactDetails";
Vue.component("contact-details", ContactDetails);
import ContactWinEdit from "../views/ContactWinEdit";
Vue.component("contact-win-edit", ContactWinEdit);

// import CardArborescence from "../views/CardArborescence";
// Vue.component("m-card-arborescence", CardArborescence);
import CatalogSearch from "../views/CatalogSearch";
Vue.component("catalog-search", CatalogSearch);
import CardProducts from "../views/CardProducts";
Vue.component("m-card-products", CardProducts);
// import CardProductsLine from "../views/CardProductsLine";
// Vue.component("m-product-line", CardProductsLine);
import ProductWinEdit from "../views/ProductWinEdit";
Vue.component("m-product-win-edit", ProductWinEdit);
import CatalogsList from "../views/CatalogsList";
Vue.component("catalogs-list", CatalogsList);
import FamilyWinEdit from "../views/FamilyWinEdit";
Vue.component("m-family-win-edit", FamilyWinEdit);
import CatalogAddProduct from "../views/CatalogAddProduct";
Vue.component("m-catalog-add-product", CatalogAddProduct);

import CardTree from "../views/CardTree";
Vue.component("card-tree", CardTree);
import CardTreeFamilyLine from "../views/CardTreeFamilyLine";
Vue.component("card-tree-family-line", CardTreeFamilyLine);
import CardTreeProductLine from "../views/CardTreeProductLine";
Vue.component("card-tree-product-line", CardTreeProductLine);
